import axios from "axios";
import { MY_JLS_TOKEN } from "@/constants/local-storage-keys";

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000,
});

axiosInstance.interceptors.request.use((config) => {
  config = {
    ...config,
    headers: { authorization: localStorage.getItem(MY_JLS_TOKEN) },
  };
  return config;
});

export default axiosInstance;
